import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { PageType } from "../../constants";
import { PitchConceptIdSearchParam } from "../../helpers/dataFetchingHelpers";
import { PitchConceptData } from "../../models/forms";
import { RouteNames } from "../../partnerConfig/routeNames";
import { OnboardingUrls } from "../../partnerConfig/routes";
import { getPitchConceptsList } from "../../redux/selectors";
import { PitchConceptState } from "../../server/crm/api/models/forms";
import { FormPreviewContainer } from "./FormPreviewContainer";
import { PitchConceptFormPreview } from "./PitchConceptFormPreview";

interface PitchConceptInfoData {
  id: string;
  pitchConceptInfo?: PitchConceptData & PitchConceptState;
}

const PitchFormPreview = () => {
  const pitchConceptsList = useSelector(getPitchConceptsList);

  const parsePitchConceptId = () => {
    if (typeof window !== "undefined" && window.location && window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(PitchConceptIdSearchParam) ?? null;
    }
    return null;
  };

  const pitchConceptId = parsePitchConceptId();
  const [pitchConceptInfoData, setPitchConceptInfoData] = useState<PitchConceptInfoData>();
  const historyElement = useHistory();

  const navigateToPitchWelcomePage = useCallback(
    () => historyElement.replace(OnboardingUrls[RouteNames.PitchWelcome]),
    [historyElement]
  );

  useEffect(() => {
    if (
      (pitchConceptId != null &&
        pitchConceptsList &&
        Object.keys(pitchConceptsList).length !== 0 &&
        pitchConceptsList[pitchConceptId] == null) ||
      pitchConceptId == null
    ) {
      navigateToPitchWelcomePage();
    }
  }, [pitchConceptId, pitchConceptsList, navigateToPitchWelcomePage]);

  useEffect(() => {
    if (pitchConceptId) {
      setPitchConceptInfoData({
        id: pitchConceptId,
        pitchConceptInfo: pitchConceptsList[pitchConceptId],
      });
    }
  }, [pitchConceptId, pitchConceptsList]);

  return (
    <FormPreviewContainer pageType={PageType.PitchApplication}>
      {pitchConceptInfoData?.pitchConceptInfo && (
        <PitchConceptFormPreview pitchConceptInfo={pitchConceptInfoData.pitchConceptInfo} />
      )}
    </FormPreviewContainer>
  );
};

export default PitchFormPreview;
